module.exports = __webpack_public_path__ + "static/Forecast2-ef2472ffd5cccab93ee74567c623295b.png";